import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

import { getIsUnderwritingCoverageAdjustmentAvailable } from "./getIsUnderwritingCoverageAdjustmentAvailable";

const getIsMembershipCoverageAdjustmentAvailable = (state: RootState) =>
  state.insuranceMembership.coverageAdjustmentAvailable;

export const getIsCoverageAdjustmentEligible = createSelector(
  getIsMembershipCoverageAdjustmentAvailable,
  getIsUnderwritingCoverageAdjustmentAvailable,
  (isMembershipCoverageAdjustmentAvailable, isUnderwritingCoverageAdjustmentAvailable) =>
    isMembershipCoverageAdjustmentAvailable && isUnderwritingCoverageAdjustmentAvailable
);
